import { observer } from "mobx-react-lite";
import { FC, useCallback, useEffect } from "react";
import cross from "../img/cross.svg";

import "./style.css";

export const PopUpRules: FC<{
  hidePopUp: () => void;
}> = observer(({ hidePopUp }) => {
  const escFunction = useCallback((evt: any) => {
    if (evt.key === "Escape") {
      hidePopUp();
    }
  }, []); // eslint-disable-line
  useEffect(() => {
    document.addEventListener("keydown", (evt) => escFunction(evt), false);

    return () => {
      document.removeEventListener("keydown", (evt) => escFunction(evt), false);
    };
  }, [escFunction]);

  return (
    <div className="newOrder_popUp" onClick={hidePopUp}>
      <div className="no_popUp" onClick={(e) => e.stopPropagation()}>
        <div className="nop_title">
          Согласие на обработку персональных данных
        </div>
        <div className="nop_content">
          <p>
            Настоящим я, заполняя форму на сайте https://rozalux-bratsk.ru ,
            выражаю своё согласие ООО «РОЗА-ЛЮКС» на обработку моих персональных
            данных, указанных мною в форме, в соответствии с Федеральным законом
            № 152-ФЗ «О персональных данных».
          </p>
          <p>
            Я подтверждаю, что ознакомлен(а) с Политикой обработки персональных
            данных, размещённой на сайте https://rozalux-bratsk.ru/policy , и
            даю согласие на использование моих данных для оформления и доставки
            заказов, связи со мной, а также для улучшения качества обслуживания.
          </p>
          <p>
            Согласие действует до момента его отзыва. Я могу отозвать согласие,
            направив уведомление по адресу электронной почты:
            ordersroselux@gmail.com.
          </p>
          <p>
            Гарантирую, что представленная мной информация является полной,
            точной и достоверной, а также что при представлении информации не
            нарушаются действующее законодательство Российской Федерации,
            законные права и интересы третьих лиц.
          </p>
        </div>
        <img
          className="nop_close"
          src={cross}
          onClick={hidePopUp}
          alt="Закрыть"
          title="Закрыть"
        />
      </div>
    </div>
  );
});
